(function ($) {
    "use strict";


    var checkoutReady = $.Deferred();

    window.LiqPayCheckoutCallback = function () {
        checkoutReady.resolveWith(LiqPayCheckout);
    };


    var containerCount = 0;

    $.fn.liqpay = function (options) {
        if (!options.data || !options.signature) return;

        return this.each(function () {
            var $this = $(this),
                id    = $this.attr('id');

            if (!id) $this.attr('id', (id = ('liqpay-container-' + ++containerCount)));

            // TODO: Save promise inside element's data attr
            $.liqpay($.extend(options, {
                mode: 'embed',
                embedTo: '#' + id
            }));
        });
    };

    $.liqpay = function (options) {
        if (!options.data || !options.signature) return;

        if (options.mode === 'redirect') {
            return $('<form>').attr({
                method: 'post',
                action: 'https://www.liqpay.ua/api/3/checkout',
                'accept-charset': 'utf-8'
            }).append(
                $('<input>').attr({
                    type: 'hidden',
                    name: 'data',
                    value: options.data
                }),
                $('<input>').attr({
                    type: 'hidden',
                    name: 'signature',
                    value: options.signature
                })
            ).css({
                visibility: 'hidden',
                position: 'absolute'
            }).appendTo(document.body)[0].submit();
        }

        var promise = $.Deferred();

        checkoutReady.done(function () {
            var opts = $.extend({
                language: 'uk',
                mode: 'popup'
            }, options);

            var target = false;

            if (opts.mode === 'embed') {
                target = opts.embedTo;
            } else if (opts.mode === 'popup') {
                target = document.body;
            }

            promise.resolveWith(
                this.init(opts)
                .on("liqpay.callback", function (data) {
                    target && $(target).trigger('liqpay.callback', [data]);
                }).on("liqpay.ready", function (data) {
                    target && $(target).trigger('liqpay.ready', [data]);
                }).on("liqpay.close", function (data) {
                    target && $(target).trigger('liqpay.close', [data]);
                })
            );
        });

        return promise.promise();
    };

    $.liqpayCheckoutReady = checkoutReady.promise();
})(window.jQuery);
